module.exports = (__webpack_require__(2))(40);


//////////////////
// WEBPACK FOOTER
// delegated ./src/router.js from dll-reference girder_plugin_slicer_cli_web
// module id = 28
// module chunks = 0